import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7382f748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = { class: "main_wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel_main_title title_22B" }, " 1:1 협의 ", -1))
const _hoisted_4 = {
  key: 0,
  class: "bg_wrap"
}
const _hoisted_5 = { class: "bg_image" }
const _hoisted_6 = { class: "channel-container" }
const _hoisted_7 = { class: "empty_info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_msg" }, " 1:1 협의중인 대화가 없습니다 ", -1))
const _hoisted_9 = {
  key: 1,
  class: "main_tab space-between"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab_16B" }, " 협의 목록 ", -1))
const _hoisted_11 = { class: "sort_status" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slide_down",
  src: "/assets/icon/btn_down_small.png",
  srcset: "/assets/icon/btn_down_small@2x.png 2x,/assets/icon/btn_down_small@3x.png 3x"
}, null, -1))
const _hoisted_13 = { class: "channel-list-container" }
const _hoisted_14 = { class: "channel_content space-between" }
const _hoisted_15 = { class: "logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "stock_info space-between" }
const _hoisted_20 = { class: "title_16B" }
const _hoisted_21 = { class: "channel_type" }
const _hoisted_22 = { class: "red_dot" }
const _hoisted_23 = {
  key: 0,
  class: "status blue"
}
const _hoisted_24 = {
  key: 1,
  class: "status mint"
}
const _hoisted_25 = { class: "white_dot" }
const _hoisted_26 = { class: "last_message" }
const _hoisted_27 = { class: "channel_status space-between" }
const _hoisted_28 = { class: "left" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "white"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divide" }, "｜", -1))
const _hoisted_32 = { class: "channel_date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.testChannelList.length===0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("button", {
                            class: "btn_groups purple_btn",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'1:1 협의중인 대화가 없습니다', 'clickContent':`클럽딜 열기`});_ctx.useCollectPartnerships()})
                          }, " 클럽딜 열기 "),
                          _createElementVNode("button", {
                            class: "btn_groups blue_btn",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'1:1 협의중인 대화가 없습니다', 'clickContent':`보유 주식 팔기`});(_ctx.user === null ? _ctx.$global.openLoginModal() : _ctx.openSellModal())})
                          }, " 보유 주식 팔기 ")
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.testChannelList.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", {
                      class: "sort",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'협의목록', 'clickContent':`보기옵션`});_ctx.createModal()})
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.viewOption) + " · " + _toDisplayString(_ctx.viewType), 1),
                      _hoisted_12
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.viewOption) + " ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortByCreated(_ctx.testChannelList), (ch) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: ch,
                    class: "channel"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          class: "img-circle img-responsive",
                          src: _ctx.getLogo(ch.stockItemId) ? _ctx.getLogo(ch.stockItemId) : '/assets/icon/company_default_img.png' ,
                          onerror: "this.src='/assets/icon/company_default_img.png'"
                        }, null, 8, _hoisted_16),
                        _hoisted_17
                      ]),
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent info",
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'협의목록', 'clickContent':`${ch.name}/${_ctx.channelType(ch.leadAngelUserId)}`});_ctx.enterChannel(ch)}
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(ch.name), 1),
                          _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
                              [_vShow, _ctx.isRead(ch) > 0]
                            ]),
                            (_ctx.channelType(ch.leadAngelUserId) === '구매')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 구매 "))
                              : (_ctx.channelType(ch.leadAngelUserId) === '판매')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, " 판매 "))
                                : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", _hoisted_25, null, 512), [
                              [_vShow, _ctx.isRead(ch) <= 0]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(ch.lastMessage), 1),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            (_ctx.getNickName(ch))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.getNickName(ch)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_30, "empty")),
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString(_ctx.parseData(ch)), 1)
                            ], 512), [
                              [_vShow, _ctx.parseData(ch) !== '']
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.prettyDateToOnemonth(ch.createdAt, 'channel')), 1)
                        ]),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_18)
                    ])
                  ], 512)), [
                    [_vShow, _ctx.viewOption.substring(0,2) === _ctx.channelType(ch.leadAngelUserId) || _ctx.viewOption === '전체']
                  ])
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}